import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const StripeReturn = ({ number, onUpdate }) => {
  const [params] = useSearchParams();
  const session = params.get("session_id");
  const cancel = params.get("stripe_cancel");
  const [message, setMessage] = useState("");
  const [retry, setRetry] = useState(0);
  const cancelRequest = useRef(null);
  useEffect(() => {
    if (!session && !cancel) return;
    let active = true;
    let timer;
    let attempts = 0;
    const poll = async () => {
      try {
        if (cancel) {
          if (!["1", "2"].includes(cancel)) return;
          const key = `${number}:${cancel}:${retry}`;
          if (cancelRequest.current?.key !== key) {
            cancelRequest.current = { key, promise: api.post(`/orders/${number}/installments/${cancel}/stripe-cancel`) };
          }
          await cancelRequest.current.promise;
          if (active) { setMessage("Pagamento interrompido. Consulta o estado da parcela antes de tentares novamente."); await onUpdate(); }
          return;
        }
        const { data } = await api.get(`/payments/status/${session}`);
        if (!active) return;
        if (data.payment_status === "paid") { setMessage("Pagamento confirmado pelo Stripe."); await onUpdate(); return; }
        if (["expired", "failed", "refunded"].includes(data.payment_status)) {
          setMessage(data.payment_status === "expired" ? "Sessão expirada ou cancelada. Na 2.ª parcela, pede ao estafeta uma nova validação antes de repetir." : "Pagamento não concluído ou reembolsado. Consulta o estado da encomenda."); await onUpdate(); return;
        }
        setMessage("A aguardar confirmação do Stripe. Não voltes a pagar enquanto verificamos.");
        if (++attempts < 20) timer = setTimeout(poll, 3000);
      } catch (e) { if (active) setMessage(e.response?.data?.detail || "Não foi possível confirmar o pagamento. Verifica novamente."); }
    };
    poll();
    return () => { active = false; clearTimeout(timer); };
  }, [session, cancel, number, onUpdate, retry]);
  if (!session && !cancel) return null;
  return <div className="rounded-xl border border-primary/30 bg-primary/5 p-4 mb-5" aria-live="polite" data-testid="stripe-return-status">
    <p className="text-sm">{message || "A verificar o pagamento…"}</p>
    <Button size="sm" variant="outline" className="mt-3" data-testid="stripe-recheck" onClick={() => setRetry((n) => n + 1)}>Verificar novamente</Button>
  </div>;
};
